/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type AssociationStatus = typeof AssociationStatus[keyof typeof AssociationStatus];


export const AssociationStatus = {
  CREATED: 'CREATED',
  COMPLETED: 'COMPLETED',
} as const;
